import { Icon } from '@iconify/react';

const ConfirmDeleteModal = ({
  name = "",
  isOrganisation = false,
  isCampaign = false,
  handleConfirmDelete,
  handleCancelDelete,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1050,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(2px)",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: "32px 28px",
          width: "90%",
          maxWidth: "480px",
          boxShadow: "0 10px 24px rgba(0, 0, 0, 0.15)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Icon
          icon="material-symbols:warning-outline-rounded"
          color="#dc3545"
          width="48"
          height="48"
          style={{ marginBottom: "16px" }}
        />

        <div style={{ fontSize: "20px", fontWeight: "600", marginBottom: "12px", color: "#333" }}>
          Delete {isCampaign ? "Campaign" : isOrganisation ? "Organisation" : "Assistant"}?
        </div>

        <p style={{ fontSize: "15px", color: "#555", lineHeight: "1.5", marginBottom: "24px" }}>
          Are you sure you want to permanently delete
          <strong> {name || (isCampaign ? "this campaign" : isOrganisation ? "this organisation" : "this assistant")}?</strong><br />
          This action cannot be undone.
        </p>

        <div style={{ display: "flex", justifyContent: "center", gap: "12px", width: "100%" }}>
          <button
            onClick={handleCancelDelete}
            style={{
              flex: 1,
              backgroundColor: "#f1f1f1",
              color: "#333",
              border: "1px solid #ccc",
              padding: "10px 16px",
              borderRadius: "6px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e0e0e0")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#f1f1f1")}
          >
            Cancel
          </button>

          <button
            onClick={handleConfirmDelete}
            style={{
              flex: 1,
              backgroundColor: "#dc3545",
              color: "#fff",
              border: "none",
              padding: "10px 16px",
              borderRadius: "6px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#bb2d3b")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#dc3545")}
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
